<script setup>
  import SidebarPanelIcon from '@/features/layout/components/SidebarPanelIcon.vue'

  const props = defineProps(['to', 'icon', 'icon-class'])
</script>

<template>
  <li>
    <RouterLink class="link" :to="props.to">
      <span class="link-icon"><SidebarPanelIcon :icon="icon" :icon-class="iconClass" /></span>
      <slot />
    </RouterLink>
  </li>
</template>

<style lang="scss" scoped>
  li {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .link {
    display: flex;
    padding: 0 16px;
    align-items: center;
    gap: 10px;
    color: var(--fm-ui-sidebar-link-color);
    border-left: 6px solid transparent;
    height: 45px;
    white-space: nowrap;
    font-weight: 400;

    &.router-link-active {
      background: var(--fm-ui-sidebar-link-active-background-color);
      color: var(--fm-ui-sidebar-link-active-color);
    }

    &:hover {
      background: var(--fm-ui-sidebar-link-hover-background-color);
      color: var(--fm-ui-sidebar-link-hover-color);
    }

    &:focus {
      background: var(--fm-ui-sidebar-link-focus-background-color);
      color: var(--fm-ui-sidebar-link-focus-color);
    }

    &:focus-within {
      background: var(--fm-ui-sidebar-link-focus-background-color);
      color: var(--fm-ui-sidebar-link-focus-color);
    }
  }

  .link-icon {
    width: 20px;

    svg {
      width: 100%;
    }
  }
</style>
